import React from "react";
import { FormattedMessage } from "react-intl";
import { Radio } from "antd";
import numeral from "numeral";
import moment from "moment";

const ReconciliationHeader = props => {
  const {
    totalAmount,
    amountToPay,
    residueAmount,
    setValueRadio,
    valueRadio,
    isMultipleReconciliation,
    isModalMovementsBigger,
    movementAmount,
    selectedMovementDetails
  } = props;

  const handleChange = e => {
    setValueRadio(e.target.value);
  };

  const amountToRender = !isMultipleReconciliation
    ? Math.abs(amountToPay)
      .toFixed(2)
      .replace(".", ",")
    : movementAmount;
  const options = isModalMovementsBigger
    ? [
      <Radio key={"Existing_1"} value={"1"}>Aggiungi scadenza esistente</Radio>,
      <Radio key={"new_1"} value={"2"}>Crea una nuova scadenza con il residuo</Radio>,
      <Radio key={"spesa_3"} value={"3"}>Spesa</Radio>,
      <Radio key={"abbuona_4"} value={"4"}>Abbuona</Radio>
    ]
    : [
      <Radio key={"new_2"} value={"1"}>Crea una nuova scadenza con il residuo</Radio>,
      <Radio key={"abbuona_2"} value={"2"}>Abbuona</Radio>
    ];

  const renderRegisteringAmountMovements = () => {    
    return <b>{numeral(Math.abs(parseFloat(amountToRender))).format("0,0.00")}</b>;
  };

  const renderTotalAmountToCover = () => {
    return <b>{numeral(Math.abs(amountToPay)).format("0,0.00")}</b>;
  };

  const renderTitle = () => {
    return isModalMovementsBigger ? (
      <FormattedMessage
        id="deadlines.reconciliation.movementsBiggerHeader"
        values={{
          registeringAmountMovements: renderRegisteringAmountMovements(),
          totalAmountToCover: renderTotalAmountToCover()
        }}
      />
    ) : (
      <FormattedMessage
        id="deadlines.reconciliation.deadlinesBiggerHeader"
        values={{
          registeringAmountDeadlines: renderRegisteringAmountMovements(),
          deadlineDate: moment(selectedMovementDetails?.transactionDate).format("DD MMM YY"),
          totalAmountDeadlines: <b>{numeral(Math.abs(totalAmount)).format("0,0.00")}</b>
        }}
      />
    );
  };

  return (
    <div
      style={
        isMultipleReconciliation
          ? {
            width: "30%",
            borderRight: "1px solid #c9d9e8",
            paddingRight: "20px"
          }
          : {}
      }
    >
      {!isMultipleReconciliation && (
        <div
          style={{
            color: "#005075",
            fontSize: "24px",
            fontWeight: "500"
          }}
        >
          Residuo scadenza: {residueAmount}
          {" €"}
        </div>
      )}
      <div
        style={{
          marginBottom: "30px",
          marginTop: "20px",
          fontSize: "16px",
          alignItems: "baseline"
        }}
      >
        {renderTitle()}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Radio.Group
          name="RadioGroup1"
          onChange={handleChange}
          value={valueRadio}
          className="dbx-reconciliation-popup-radiogroup"
        >
          {options}
        </Radio.Group>
      </div>
    </div>
  );
};

export default ReconciliationHeader;
